module.exports = __webpack_public_path__ + "img/nintendo.c1420dbb.png";